require("@fancyapps/fancybox");

$('[data-fancybox]').fancybox({ 
    infobar: false, 
    buttons:  [ "close" ], 
    animationEffect: false,
});